import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../store'

export type ErrorCase =
    | 'MoveBookNoAvailabilities'
    | 'MoveBookBadData'
    | 'RebookBadData'
    | 'BasisTypesLoadError'
    | 'LoadCalendarError'
    | 'NoPartnersAvailable'
    | 'GetPaymentInfoError'
    | 'FinalizeError'
    | 'LeadCreationError'
    | 'MoveBookFinalizeError'
    | 'MoveBookInPast'
    | 'MoveBookCancelled'
    | 'MoveBookWithin24Hours'
    | 'CancelBookAlreadyCancelled'
    | 'CancelBookingInThePast'
    | 'Default'
    | 'OverlappingError'
const initialState: {
    bookingId?: string
    flow?: string
    preferedPartnerId?: number
    isLoading: boolean
    isMobile: boolean
    errorCase: ErrorCase
} = {
    isLoading: false,
    isMobile: true,
    errorCase: 'Default',
}

export const appSettingsSlice = createSlice({
    name: 'appSettings',
    initialState,
    reducers: {
        setBookingId: (state, action: PayloadAction<string | undefined>) => {
            state.bookingId = action.payload
        },
        setFlow: (state, action: PayloadAction<string | undefined>) => {
            state.flow = action.payload
        },
        setPreferedParnterId: (
            state,
            action: PayloadAction<number | undefined>
        ) => {
            state.preferedPartnerId = action.payload
        },
        setIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload
        },
        setIsMobile: (state, action: PayloadAction<boolean>) => {
            state.isMobile = action.payload
        },
        setErrorcase: (state, action: PayloadAction<ErrorCase>) => {
            state.errorCase = action.payload
        },
    },
})

export const {
    setBookingId,
    setFlow,
    setPreferedParnterId,
    setIsLoading,
    setIsMobile,
    setErrorcase,
} = appSettingsSlice.actions

// Other code such as selectors can use the imported `RootState` type
export const getBookingId = (state: RootState): string | undefined =>
    state.appSettings.bookingId
export const getFlow = (state: RootState): string | undefined =>
    state.appSettings.flow
export const getPreferedPartnerId = (state: RootState): number | undefined =>
    state.appSettings.preferedPartnerId
export const getIsLoading = (state: RootState): boolean =>
    state.appSettings.isLoading
export const getIsMobile = (state: RootState): boolean =>
    state.appSettings.isMobile
export const getErrorCase = (state: RootState): ErrorCase =>
    state.appSettings.errorCase

export default appSettingsSlice.reducer
